import __vue_normalize__ from '@gig/magic-wand/dist/build/rollup/vue-helpers/normalize-component.js';
import __vue_create_injector__ from 'vue-runtime-helpers/dist/inject-style/browser.mjs';
import magicStyles from './balance.magic.css.js';
import Balance from './balance.js';

const __vue_script__ = Balance;

/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _vm.balance
    ? _c(
        "magic-router-link",
        {
          staticClass: "balance",
          class: {
            "balance--compact": _vm.compact,
            "balance--gameplay": _vm.gameplay,
            "balance--top-navigation": _vm.isTopNavigationEnabled
          },
          attrs: {
            part: _vm.$p("balance", {
              "balance--compact": _vm.compact,
              "balance--gameplay": _vm.gameplay,
              "balance--top-navigation": _vm.isTopNavigationEnabled
            }),
            to: _vm.RoutablePage.WALLET_DEPOSIT
          }
        },
        [
          _c("div", { staticClass: "detail", attrs: { part: "detail" } }, [
            _c(
              "div",
              {
                class: _vm.isTopNavigationEnabled ? "total--top-nav" : "",
                attrs: { part: "total" }
              },
              [
                _c(
                  "div",
                  {
                    class: _vm.isTopNavigationEnabled ? "balance-details" : ""
                  },
                  [
                    _c("magic-ui-text", {
                      staticClass: "amount amount--total",
                      attrs: {
                        part: "amount amount--total",
                        content: _vm._f("formatCurrency")(
                          _vm.balance.balance,
                          _vm.currency
                        ),
                        "data-v-test-id": "total-balance-amount"
                      }
                    }),
                    _vm._v(" "),
                    !_vm.isTopNavigationEnabled
                      ? _c(
                          "div",
                          { staticClass: "list", attrs: { part: "list" } },
                          [
                            _c(
                              "div",
                              { staticClass: "item", attrs: { part: "item" } },
                              [
                                _c("magic-ui-text", {
                                  staticClass: "title",
                                  attrs: {
                                    part: "title",
                                    content: _vm.$t("balance.real-balance")
                                  }
                                }),
                                _vm._v(" "),
                                _c("magic-ui-text", {
                                  staticClass: "amount",
                                  attrs: {
                                    part: "amount",
                                    content: _vm._f("formatCurrency")(
                                      _vm.realMoneyBalance,
                                      _vm.currency
                                    )
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "item", attrs: { part: "item" } },
                              [
                                _c("magic-ui-text", {
                                  staticClass: "title",
                                  attrs: {
                                    part: "title",
                                    content: _vm.$t("balance.bonus-balance")
                                  }
                                }),
                                _vm._v(" "),
                                _c("magic-ui-text", {
                                  staticClass: "amount",
                                  attrs: {
                                    part: "amount",
                                    content: _vm._f("formatCurrency")(
                                      _vm.balance.bonusBonusMoneyBalance,
                                      _vm.currency
                                    )
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm.hasExtraItem()
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "item",
                                    attrs: { part: "item" }
                                  },
                                  [_vm._t("extra-item")],
                                  2
                                )
                              : _vm._e()
                          ]
                        )
                      : _c(
                          "div",
                          { staticClass: "list", attrs: { part: "list" } },
                          [
                            _c("div", { staticClass: "list--item" }, [
                              _vm.realMoneyBalance !== false
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "item",
                                      attrs: { part: "item" }
                                    },
                                    [
                                      _c("magic-ui-text", {
                                        staticClass: "title",
                                        attrs: {
                                          part: "title",
                                          content: _vm.$t(
                                            "balance.real-balance"
                                          )
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("magic-ui-text", {
                                        staticClass: "amount",
                                        attrs: {
                                          part: "amount",
                                          content: _vm._f("formatCurrency")(
                                            _vm.realMoneyBalance,
                                            _vm.currency
                                          )
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "item",
                                  attrs: { part: "item" }
                                },
                                [
                                  _c("magic-ui-text", {
                                    staticClass: "title",
                                    attrs: {
                                      part: "title",
                                      content: _vm.$t("balance.bonus-balance")
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("magic-ui-text", {
                                    staticClass: "amount",
                                    attrs: {
                                      part: "amount",
                                      content: _vm._f("formatCurrency")(
                                        _vm.balance.bonusBalance,
                                        _vm.currency
                                      )
                                    }
                                  })
                                ],
                                1
                              )
                            ]),
                            _vm._v(" "),
                            _vm.hasExtraItem()
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "item",
                                    attrs: { part: "item" }
                                  },
                                  [_vm._t("extra-item")],
                                  2
                                )
                              : _vm._e()
                          ]
                        )
                  ],
                  1
                ),
                _vm._v(" "),
                _vm._t("aside", [
                  _c(
                    "magic-ui-button",
                    {
                      staticClass: "button",
                      attrs: {
                        round: !_vm.isTopNavigationEnabled,
                        "no-padding": "",
                        icon: "",
                        "no-margin": "",
                        part: "button",
                        variant: "primary",
                        "aria-label": "+",
                        to: _vm.RoutablePage.WALLET_DEPOSIT
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          class: _vm.isTopNavigationEnabled
                            ? "deposit-icon-wrapper--top-nav"
                            : "deposit-icon-wrapper"
                        },
                        [
                          _c("magic-ui-icon", {
                            staticClass: "icon",
                            attrs: {
                              name: _vm.isTopNavigationEnabled
                                ? "deposit"
                                : "plus",
                              part: "icon"
                            }
                          })
                        ],
                        1
                      )
                    ]
                  )
                ])
              ],
              2
            )
          ])
        ]
      )
    : _vm._e()
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-a4169da2_0", { source: magicStyles, map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = "data-v-a4169da2";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  );

export default __vue_component__;
